import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationApprovalsRepository } from '../../../infrastructure/repositories/investigation-approvals.repository';
import { LoadInvestigationApprovalsWithPagingQuery } from './load-investigation-approvals-with-paging.query';
import { LoadInvestigationApprovalsWithPagingResult } from './load-investigation-approvals-with-paging.result';

@Injectable({ providedIn: 'root' })
export class LoadInvestigationApprovalsWithPagingUseCase {
  private readonly _repository = inject(InvestigationApprovalsRepository);

  public execute(query: LoadInvestigationApprovalsWithPagingQuery): Observable<LoadInvestigationApprovalsWithPagingResult> {
    return this._repository.getApprovalsWithPaging(query);
  }
}
